import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';
import { Text13Regular } from '../../utils/Text/Text.styles';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    width: unset;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.4rem;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

export const SubmitButton = styled(Button)`
  width: 16rem;
`;

export const NoteText = styled(Text13Regular)`
  margin-bottom: 1.2rem;
  color: red;
  width: 90%;
`;
